import { useEffect, useMemo, useState } from 'react';
import getAPIClient from '../hooks/apiClient';
import s from './ConstraintTemplatePicker.module.scss';

export default function ConstraintTemplatePicker({ BX24, onPick, onClose }) {
    const api = useMemo(() => getAPIClient(BX24), []);
    const [templates, setTemplates] = useState([]);
    const [filter, setFilter] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const response = await api.get('/analysis_agent/constraint_templates/');
                if (!cancelled) setTemplates(response.data || []);
            } catch (e) {
                console.error('Constraint templates load failed', e);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [api]);

    const filtered = useMemo(() => {
        const q = filter.trim().toLowerCase();
        if (!q) return templates;
        return templates.filter((t) => (t.text || '').toLowerCase().includes(q));
    }, [templates, filter]);

    return (
        <div className={s.backdrop} role="dialog" aria-modal="true">
            <div className={s.modal}>
                <div className={s.header}>
                    <h3>Шаблоны ограничений</h3>
                    <button type="button" className={s.close} onClick={onClose} aria-label="Закрыть">×</button>
                </div>
                <div className={s.toolbar}>
                    <input
                        className={s.search}
                        type="text"
                        placeholder="Поиск по формулировке…"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        autoFocus
                    />
                </div>
                <div className={s.list}>
                    {loading && <div className={s.empty}>Загрузка…</div>}
                    {!loading && filtered.length === 0 && (
                        <div className={s.empty}>Нет подходящих шаблонов</div>
                    )}
                    {!loading && filtered.map((t) => (
                        <button
                            key={t.id}
                            type="button"
                            className={s.row}
                            onClick={() => {
                                onPick({ text: t.text });
                                onClose();
                            }}
                        >
                            <span className={s.rowText}>{t.text}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}